// Instellingen per scherm (elke tv heeft een eigen Pi), net als renderTier via de URL gezet en bewaard.
//   ?screen=teeview   naam van dit scherm in de console
//   ?dark=45          seconden zonder beeld voor "tv uit" (standaard screenDarkMs)
//   ?dark=auto        terug naar de standaard

import { screenDarkMs } from "../constants";

const nameKey = "tdScreenName";
const darkKey = "tdScreenDarkMs";

function read(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // Kiosk zonder opslag: dan geldt de instelling alleen deze sessie.
    return null;
  }
}

function write(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* mag het dashboard niet ophouden */
  }
}

function param(key) {
  try {
    return new URLSearchParams(window.location.search).get(key);
  } catch {
    return null;
  }
}

let cachedName = null;
let cachedDarkMs = null;

// Naam voor de logs; zonder ?screen= krijgt het apparaat één keer een willekeurige eigen naam.
export function deviceName() {
  if (cachedName) return cachedName;

  const asked = param("screen");
  if (asked) write(nameKey, asked);
  cachedName = asked || read(nameKey);
  if (!cachedName) {
    cachedName = `scherm-${Math.random().toString(36).slice(2, 6)}`;
    write(nameKey, cachedName);
  }
  return cachedName;
}

// Zo lang zonder beeld telt als "tv uit"; per scherm in te stellen, want een trage Pi slaat wel eens een tel over.
export function darkAfterMs() {
  if (cachedDarkMs !== null) return cachedDarkMs;

  const asked = param("dark");
  const seconds = Number(asked);
  if (asked === "auto") {
    write(darkKey, "");
    cachedDarkMs = screenDarkMs;
  } else if (asked && Number.isFinite(seconds) && seconds > 0) {
    cachedDarkMs = seconds * 1000;
    write(darkKey, String(cachedDarkMs));
  } else {
    const saved = Number(read(darkKey));
    cachedDarkMs = Number.isFinite(saved) && saved > 0 ? saved : screenDarkMs;
  }
  return cachedDarkMs;
}
